import { Typography } from '@material-ui/core'
import React from 'react'

interface Props {
    bold?: boolean
    children: any
}

export default function Label({
    bold,
    children
}: Props) {
    return (
        <Typography style={bold ? { fontWeight: 'bold' } : {}}>
            {children}
        </Typography>
    )
}
